import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { FeatureNamesQueryType } from "@reflag/shared/featureAPI";

import { featureQueryKeys } from "./featureQueryKeys";

export function useFeatureNamesData(
  searchParams: Partial<FeatureNamesQueryType> = {},
  opts?: { retry?: boolean; enabled?: boolean },
) {
  const { appId } = useEnvironment();

  // Avoid literal undefined as it becomes the string 'undefined' in search params
  const cleanSearchParams: Partial<FeatureNamesQueryType> = Object.fromEntries(
    Object.entries(searchParams).filter(
      ([_key, value]) => typeof value !== "undefined",
    ),
  );

  const search = new URLSearchParams();
  Object.entries(cleanSearchParams).forEach(([key, value]) => {
    search.set(key, String(value));
  });

  const dataUrl = `/apps/${appId}/features/names?${search.toString()}`;

  return useQuery({
    queryKey: featureQueryKeys.listNames(appId, cleanSearchParams),

    queryFn: () =>
      api.get<"/apps/:appId/features/names">(dataUrl).then((res) => res.data),
    enabled: !!appId && opts?.enabled !== false,
    staleTime: 5 * 60 * 1000,
    refetchInterval(query) {
      if (opts?.retry === true) {
        if (!query.state.data?.length) {
          return 500;
        }
      }
      return false;
    },
  });
}
